import { Reaction, styled, css, ORIENTATION_LEFT } from '@moleculeone/ui';

import { chunkConditions } from './chunkConditions';

const ReferencesContainer = styled('div', {
  borderBottomLeftRadius: '6px',
  borderBottomRightRadius: '6px',
  outline: 'none',
  position: 'relative',
  overflow: 'hidden',
});
const ReferencesInnerContainer = styled('div', {
  height: 'calc(100vh - 370px)',
  margin: '0 -$8',
  overflow: 'auto',
});

const ReferenceContainer = styled('div', {
  'padding': '$6 $8',
  '&:not(:last-child)': {
    borderBottom: '1px solid $slate5',
  },
});

const ReactionContainer = styled('div', {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: '$6 $7',
});

const reactionStyle = css({
  flexGrow: 1,
  mixBlendMode: 'darken',
});
const reactionClassName = reactionStyle();

const ArrowContext = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  color: '$slate12',
});

const AdditionalInfo = styled('div', {
  fontSize: '$1',
  textAlign: 'center',
});
const AdditionalInfoLabel = styled('span', {
  color: '$slate11',
});

export type ReferenceReaction = {
  product: string;
  substrates: [string, string];
  product_to_map: number[];
  substrates_to_map: number[][];
  other_reagents: Record<string, string>;
  similarity: number;
  reaction_id: string;
  reaction_yield: number;
  conditions: {
    temperature: number;
    time_in_h: number;
  };
};

interface YieldReferencesProps {
  references: ReferenceReaction[];
}
export function YieldReferences({ references }: YieldReferencesProps) {
  return (
    <ReferencesContainer>
      <ReferencesInnerContainer>
        {references.map((reference, idx) => {
          const { firstConditionsChunk, secondConditionsChunk } = chunkConditions({
            ...reference.other_reagents,
            ...reference.conditions,
          });

          return (
            <ReferenceContainer key={idx}>
              <ReactionContainer>
                <Reaction
                  className={reactionClassName}
                  reaction={{
                    product: reference.product,
                    substrates: reference.substrates,
                  }}
                  productMap={[]}
                  substratesMap={[]}
                  size={10}
                  orientation={ORIENTATION_LEFT}
                  showDisconnections={false}
                  showSubstrates={true}
                  shouldAlignSubstrates={false}
                  arrowProps={{
                    lengthScale: 3,
                    topContext: <ArrowContext>{firstConditionsChunk}</ArrowContext>,
                    bottomContext: (
                      <ArrowContext>
                        {secondConditionsChunk}
                        <AdditionalInfo>
                          <AdditionalInfoLabel>yield:</AdditionalInfoLabel>{' '}
                          {(reference.reaction_yield * 100).toFixed(0)}%
                        </AdditionalInfo>
                        {/* <AdditionalInfo>
                            <AdditionalInfoLabel>
                              similarity:
                            </AdditionalInfoLabel>{' '}
                            {reference.similarity}
                          </AdditionalInfo> */}
                      </ArrowContext>
                    ),
                  }}
                />
              </ReactionContainer>
            </ReferenceContainer>
          );
        })}
      </ReferencesInnerContainer>
    </ReferencesContainer>
  );
}
